module.exports = __webpack_public_path__ + "static/media/error_bill_paid.06b17a71.svg";